export interface ApiErrorResponse {
  response?: {
    status?: number;
    data?: Record<string, unknown>;
  };
}

export function isApiError(err: unknown): err is ApiErrorResponse {
  return err !== null && typeof err === "object" && "response" in err;
}

export function isUnauthorized(err: unknown): boolean {
  return isApiError(err) && err.response?.status === 401;
}

function extractMessage(
  data: Record<string, unknown> | null | undefined,
): string | null {
  if (!data || typeof data !== "object") return null;
  if (typeof data.message === "string" && data.message.trim())
    return data.message;
  if (typeof data.error === "string" && data.error.trim()) return data.error;
  if (typeof data.detail === "string" && data.detail.trim()) return data.detail;
  if (Array.isArray(data.errors) && data.errors.length > 0) {
    const first = data.errors[0];
    if (typeof first === "string") return first;
    if (
      typeof first === "object" &&
      first &&
      typeof (first as { message?: string }).message === "string"
    ) {
      return (first as { message: string }).message;
    }
  }
  return null;
}

export function getApiErrorMessage(
  err: unknown,
  fallback = "An unexpected error occurred. Please try again.",
): string {
  if (isApiError(err) && err.response?.data) {
    const msg = extractMessage(
      err.response.data as Record<string, unknown>,
    );
    if (msg) return msg;
  }
  if (isUnauthorized(err)) {
    return "Invalid email or password";
  }
  return fallback;
}
